<div class="properties-showcase-container" *ngIf="properties?.length > 0">
  <div fxLayout fxLayoutGap="25px" fxLayoutAlign="start center" fxHide.lt-lg class="rules__rule-header">
    <div fxFlex fxLayoutGap="12px" fxLayoutAlign="start center">
      <div fxFlex="36px">
        <mat-checkbox
          *ngIf="allPropertiesEnabled"
          fxFlex="36px"
          [matTooltip]="true ? '' : 'All properties in my portfolio, including ones I add in the future.'"
          [checked]="futureProperties"
          (change)="futurePropertiesChanged($event)"></mat-checkbox>
      </div>
      <div fxFlex>Property name</div>
    </div>

    <ng-container *ngIf="properties[0].checks">
      <div
        fxLayoutAlign="center center"
        fxFlex="60px"
        *ngFor="let check of properties[0].checks | ignorePropertyChecks: ['google_vacation_rentals']">
        <span>{{ check.label }}</span>
      </div>
    </ng-container>

    <div fxFlex="20px"></div>
  </div>

  <div class="drag-container" cdkDropList (cdkDropListDropped)="drop($event)">
    <div
      fxLayout
      class="rules__rule-container"
      cdkDrag
      [cdkDragDisabled]="!reorderEnabled || selectedProperties.indexOf(property.id) === -1"
      *ngFor="let property of properties"
      [class.property__unlisted]="property.listed === false">
      <div *ngIf="selectedProperties.indexOf(property.id) > -1 && reorderEnabled" class="drag-handle">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="drag-indicator">
          <path fill="none" d="M0 0h24v24H0V0z"></path>
          <path
            d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
        </svg>
      </div>

      <div fxFlexFill fxLayoutAlign="start center" fxLayoutGap="24px">
        <div fxLayout="column" fxFlex>
          <div fxFlex fxLayout fxLayoutGap="12px" fxLayoutAlign="start center">
            <mat-checkbox
              fxFlex="36px"
              [disabled]="
                (property.checks | ignorePropertyChecks: ['google_vacation_rentals'] | propertyHasBlockCheck) &&
                selectedProperties.indexOf(property.id) === -1
              "
              [checked]="selectedProperties.indexOf(property.id) > -1"
              (change)="propertyAddedOrRemoved($event, property.id)"></mat-checkbox>

            <div
              fxFlex
              fxLayout="column"
              fxLayoutGap="2px"
              class="rule__title ellipsis"
              [class.clickable]="mode === 'widget' && selectedProperties.indexOf(property.id) > -1"
              [matTooltip]="!property.listed ? 'This property is unlisted on other channels' : null">
              <strong
                class="night-darker ellipsis"
                (click)="
                  mode === 'widget' && selectedProperties.indexOf(property.id) > -1 ? openSlugModal(property) : null
                ">
                {{ property.name }}
              </strong>
              <sbnb-cs-debug-item
                label="Property ID"
                [coreNovaLink]="'/resources/properties/' + property.id"
                [value]="property.id.toString()"
                linkLabel="Nova"></sbnb-cs-debug-item>

              <div
                *ngIf="property.public_name && property.public_name !== property.name"
                fxFlex
                class="text__small night ellipsis"
                style="margin-top: 4px"
                (click)="
                  mode === 'widget' && selectedProperties.indexOf(property.id) > -1 ? openSlugModal(property) : null
                ">
                {{ property.public_name }}
              </div>

              <div
                *ngIf="mode === 'site' && site.publish_status === SitePublishStatuses.Published && property.slug"
                fxFlex
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                class="text__small night-lighter">
                <a
                  [href]="'https://' + direct.getSiteFullURL(site) + '/property/' + property.slug"
                  target="_blank"
                  matTooltip="Open site in new tab"
                  class="ellipsis"
                  style="direction: rtl">
                  <span>{{ direct.getSiteFullURL(site) }}/property/{{ property.slug }}</span>
                </a>

                <mat-icon
                  fxFlex="16px"
                  (click)="copyPropertyURL(property)"
                  style="cursor: pointer"
                  [matTooltip]="'Copy Property URL to clipboard'">
                  content_copy
                </mat-icon>
              </div>

              <div
                *ngIf="
                  mode === 'widget' &&
                  propertyUrls?.length > 0 &&
                  (propertyUrls | getPropertyUrl) &&
                  selectedProperties.indexOf(property.id) > -1
                "
                class="text__small night"
                (click)="
                  mode === 'widget' && selectedProperties.indexOf(property.id) > -1 ? openSlugModal(property) : null
                ">
                {{ propertyUrls | getPropertyUrl: property.id }}
              </div>

              <div
                *ngIf="selectedProperties.indexOf(property.id) > -1 && mode === 'widget'"
                fxFlex
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                class="text__small night-lighter clickable"
                (click)="openCopyWidgetModal(property.id)">
                <span>Copy widget code</span>

                <mat-icon fxFlex="16px">content_copy</mat-icon>
              </div>
            </div>
          </div>
          <div fxHide fxShow.lt-lg fxLayout fxLayoutGap="12px" style="margin-top: 4px; margin-left: 48px">
            <ng-container *ngIf="property.checks">
              <div *ngFor="let check of property.checks | ignorePropertyChecks: ['google_vacation_rentals']">
                <ng-container [ngSwitch]="check.result">
                  <div *ngSwitchCase="'pass'" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <sbnb-icon icon="check" class="text-grass-darker" [matTooltip]="check.notes"></sbnb-icon>
                    <span class="text__xsmall">{{ check.label }}</span>
                  </div>
                  <div *ngSwitchCase="'warn'" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <img [matTooltip]="check.notes" src="/assets/iconography/warning.svg" width="20px" height="20px" />
                    <span class="text__xsmall">{{ check.label }}</span>
                  </div>
                  <div *ngSwitchCase="'block'" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <img [matTooltip]="check.notes" src="/assets/iconography/error.svg" width="16px" height="18px" />
                    <span class="text__xsmall">{{ check.label }}</span>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="property.checks">
          <div
            fxHide.lt-lg
            *ngFor="let check of property.checks | ignorePropertyChecks: ['google_vacation_rentals']"
            fxFlex="60px">
            <ng-container [ngSwitch]="check.result">
              <div *ngSwitchCase="'pass'" fxLayoutAlign="center center">
                <sbnb-icon icon="check" class="text-grass-darker" [matTooltip]="check.notes"></sbnb-icon>
              </div>
              <div *ngSwitchCase="'warn'" fxLayoutAlign="center center">
                <img [matTooltip]="check.notes" src="/assets/iconography/warning.svg" width="20px" height="20px" />
              </div>
              <div *ngSwitchCase="'block'" fxLayoutAlign="center center">
                <img [matTooltip]="check.notes" src="/assets/iconography/error.svg" width="16px" height="18px" />
              </div>
              <div *ngSwitchCase="'loading'" fxLayoutAlign="center center">
                <mat-spinner diameter="16"></mat-spinner>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div fxFlex="20px">
          <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu"></sbnb-more-menu-trigger>
          <mat-menu #actionsMenu="matMenu">
            <a [routerLink]="['/properties/property/' + property.id]">
              <button mat-menu-item disableRipple>
                <span fxLayoutAlign="start center" fxLayoutGap="6px">
                  <span>Edit property details</span>
                </span>
              </button>
            </a>

            <button
              *ngIf="
                (mode === 'site' && site.publish_status === SitePublishStatuses.Published) ||
                (mode === 'widget' && selectedProperties.indexOf(property.id) > -1)
              "
              mat-menu-item
              disableRipple
              (click)="openSlugModal(property)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <span>Edit property URL</span>
              </span>
            </button>

            <button
              *ngIf="mode === 'widget' && selectedProperties.indexOf(property.id) > -1"
              mat-menu-item
              disableRipple
              (click)="validatePropertyUrl(property)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <span>Validate URL</span>
              </span>
            </button>

            <button
              *ngIf="mode === 'widget' && selectedProperties.indexOf(property.id) > -1"
              mat-menu-item
              disableRipple
              (click)="openCopyWidgetModal(property.id)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <span>Copy widget code</span>
              </span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>
